import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormInputField, lt } from '@mews/framework';
import { Stack, Typography } from '@optimus-web/core';
import { autofillFormatter } from '../../../utils/autofillFormatter';
import { FieldNames, type FormValues } from '../formEnums';

interface Props {
    isEdit?: boolean;
}
export const MappingFields = ({ isEdit }: Props) => {
    const { watch, clearErrors, setValue, getFieldState } = useFormContext<FormValues>();

    const { error: keyError } = getFieldState(FieldNames.Key);
    const { error: nameError } = getFieldState(FieldNames.Name);
    const productNameValue = watch(FieldNames.Name);
    const productKeyValue = watch(FieldNames.Key);

    useEffect(() => {
        if (!nameError && keyError && productKeyValue) clearErrors(FieldNames.Key);
    }, [clearErrors, keyError, productKeyValue, nameError]);

    useEffect(() => {
        if (!isEdit) {
            const { shortName, productKey } = autofillFormatter(productNameValue);

            setValue(FieldNames.Key, productKey);
            setValue(FieldNames.ShortName, shortName);
        }
    }, [isEdit, productNameValue, setValue]);
    return (
        <>
            <Typography textStyle="bodyLargeStrong" as="div">
                {lt('Mapping')}
            </Typography>
            <Stack vertical spacing="50">
                <FormInputField label={lt('ProductKey')} name={FieldNames.Key} required={!isEdit} disabled={isEdit} />
                <Typography textStyle="bodySmall" variant="secondary" as="div">
                    {lt('ProductKeyHint')}
                </Typography>
            </Stack>
            <Stack vertical spacing="50">
                <FormInputField label={lt('ExternalIdentifier')} name={FieldNames.ExternalIdentifier} />
                <Typography textStyle="bodySmall" variant="secondary" as="div">
                    {lt('ExternalIdentifierHint')}
                </Typography>
            </Stack>
        </>
    );
};
